import * as React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useSiteQuery, useLocalPath } from "../hooks"
import { mapLangSelector, mapLocale } from "../utils/mapping"
function Seo({
    description,
    lang,
    meta,
    title,
    node_locale,
    hreflangs = [],
    slug,
    schemas = null,
    content,
    noIndex = false
}) {
    const { site } = useStaticQuery(
        graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
    )

    const localeSlug = useLocalPath(slug && slug[0] === '/' ? slug.substring(1) : `${slug}`)
    const siteUrl = process.env.URL || 'http://localhost:8000/'
    const newSlug = localeSlug[0] === '/' ? localeSlug.substring(1) : localeSlug
    const finalUrl = siteUrl[siteUrl.length - 1] === '/' ? `${siteUrl}${newSlug}` : `${siteUrl}/${newSlug}`
    // const node_locale = useLocale()
    const { mobileLogo } = useSiteQuery()
    let seoImage = mobileLogo?.image?.file.url
    const metaDescription = description || site.siteMetadata.description
    const defaultTitle = site.siteMetadata?.title
    switch (lang) {
        case "uk/en":
            lang = "en"
            break
        case "us/en":
            lang = "en"
            break
        case "us/es":
            lang = "es"
            break
        case "pl":
            lang = "pl"
            break
        case "ca/en":
            lang = "en"
            break
        case "ca/fr":
            lang = "fr"
            break
        case "tr":
            lang = "tr"
            break
        case "fr":
            lang = "fr"
            break
        case "nl/nl":
            lang = "nl"
            break
        case "be/fr":
            lang = "fr"
            break
        case "jp/ja":
            lang = "ja"
            break
        case "pk/ur":
            lang = "ur"
            break
        case "pk/en":
            lang = "en"
            break
        case "middle-east/ar":
            lang = "ar"
            break
        case "middle-east/en":
            lang = 'en'
            break
        default:
            lang = "en"
    }
    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
            meta={[
                {
                    name: `market`,
                    content: node_locale
                },
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:image`,
                    content: `https:${seoImage}`
                },
                {
                    property: `og:image:secure_url`,
                    content: `https://secure.${seoImage.substr(2)}`
                },
                {
                    property: `og:image:type`,
                    content: `image/jpeg`
                },
                {
                    property: `og:image:width`,
                    content: `400`
                },
                {
                    property: `og:image:height`,
                    content: `300`
                },
                {
                    property: `og:image:alt`,
                    content: `ekaterra`
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata?.author || ``,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ].concat(meta)}
        >
            <link rel="canonical" href={finalUrl} />
            {content ? <meta name="google-site-verification" content="mjQvznz-8oYgeDOni8H6NmWyfyrFqbdeOpjekQx87yA" /> : null}
            {
                schemas
                    ? schemas.map((schema, index) => (<script key={index} type='application/ld+json'>{JSON.stringify(schema)}</script>))
                    : null
            }
            {
                hreflangs.map(({ slug, node_locale }, index) => {
                    return slug === '/'
                        ? slug && node_locale && mapLocale[node_locale] && (<link key={index} rel="alternate" title={mapLangSelector[node_locale]} hrefLang={node_locale} href={`https://ekaterratea.com/${mapLocale[node_locale]}/`} />)
                        : slug && node_locale && mapLocale[node_locale] && (<link key={index} rel="alternate" title={mapLangSelector[node_locale]} hrefLang={node_locale} href={`https://ekaterratea.com/${mapLocale[node_locale]}/${slug}/`} />)
                })
            }
            {
                noIndex
                    ? <meta name="robots" content="noindex" />
                    : null
            }
        </Helmet>
    )
}

Seo.defaultProps = {
    lang: `en`,
    meta: [],
    description: ``,
}

Seo.propTypes = {
    description: PropTypes.string,
    lang: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.object),
    title: PropTypes.string.isRequired,
}

export default Seo
